import styled from "styled-components";

export const AccordionContainer = styled.div`
	background: ${({ theme }) => theme.grayLight} !important;
	padding: 0.6rem 0 !important;
	margin: 0 0 1rem !important;
	border-radius: 4px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
`;

export const AccordionTitle = styled.h5`
	font-weight: bold !important;
	margin: 0 0 5px 0 !important;
	padding: 0 16px !important;
`;

export const AccordionDetailsHistory = styled.div`
	display: flex;
	flex-direction: column;
	background: #fff !important;
	margin: 0 10px 0 10px;
	padding: 5px 5px !important;
`;

export const ContainerLabel = styled.div`
	display: flex;
	flex-direction: row;
`;

export const LabelItem = styled.div`
	color: ${({ theme }) => theme.pantoneBlack};
	font-weight: bold;
	margin: 0 0.4rem;
`;

export const LabelResult = styled.div`
	color: ${({ theme }) => theme.pantoneBlack};
`;
